import {
  getUserLicense,
  getLicenseSeats,
  getSeatInvitations,
  assignSeat,
  unassignSeat,
  assignOrganizationMemberSeat,
  unassignOrganizationMemberSeat,
  removeOrganizationMember,
  inviteSeat,
  cancelSeatInvitation,
  resendSeatInvitation,
  acceptSeatInvitation,
  getCustomDomains,
  requestCustomDomain,
  verifyCustomDomain,
  removeCustomDomain,
  getBrandingProfiles,
  getJoinedBrandingProfiles,
  createBrandingProfile,
  updateBrandingProfile,
  deleteBrandingProfile,
  getSsoConfigurations,
  createSsoConfiguration,
  updateSsoConfiguration,
  deleteSsoConfiguration,
  getSsoMetadata,
  downloadSsoMetadataFile,
  fetchSsoMetadataFromUrl,
  createSubscriptionCheckout,
  completeSubscriptionCheckout,
  createBillingPortalSession,
  createInvoicePortalSession,
  createCancelSubscriptionPortal,
  updateSubscriptionSeats,
  previewSubscriptionSeats,
  syncSubscription,
  updateLicense,
  cancelLicense,
  getSubdomains,
  createSubdomain,
  updateSubdomain,
  deleteSubdomain,
  checkSubdomainAvailability,
  uploadBrandingLogo,
  deleteBrandingLogo,
  getJoinedOrganizations,
  leaveJoinedOrganization,
  getOrganizationMembers
} from './api';

export const LicenseService = {
  getUserLicense,
  getLicenseSeats,
  getSeatInvitations,
  assignSeat,
  unassignSeat,
  assignOrganizationMemberSeat,
  unassignOrganizationMemberSeat,
  removeOrganizationMember,
  inviteSeat,
  cancelSeatInvitation,
  resendSeatInvitation,
  acceptSeatInvitation,
  getCustomDomains,
  requestCustomDomain,
  verifyCustomDomain,
  removeCustomDomain,
  getBrandingProfiles,
  getJoinedBrandingProfiles,
  createBrandingProfile,
  updateBrandingProfile,
  deleteBrandingProfile,
  getSsoConfigurations,
  createSsoConfiguration,
  updateSsoConfiguration,
  deleteSsoConfiguration,
  getSsoMetadata,
  downloadSsoMetadataFile,
  fetchSsoMetadataFromUrl,
  createSubscriptionCheckout,
  completeSubscriptionCheckout,
  createBillingPortalSession,
  createInvoicePortalSession,
  createCancelSubscriptionPortal,
  updateSubscriptionSeats,
  previewSubscriptionSeats,
  syncSubscription,
  updateLicense,
  cancelLicense,
  getSubdomains,
  createSubdomain,
  updateSubdomain,
  deleteSubdomain,
  checkSubdomainAvailability,
  uploadBrandingLogo,
  deleteBrandingLogo,
  getJoinedOrganizations,
  leaveJoinedOrganization,
  getOrganizationMembers
};
